import {Injectable} from '@angular/core';
import {LoaderState} from '../domain/loader-state';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderRequestService {

    private backgroundRequests = 0;
    private foregroundRequests = 0;

    private backgroundLoadingSubject = new BehaviorSubject<boolean>(false);
    private foregroundLoadingSubject = new BehaviorSubject<boolean>(false);

    readonly backgroundLoading$ = this.backgroundLoadingSubject.asObservable();
    readonly foregroundLoading$ = this.foregroundLoadingSubject.asObservable();

    constructor() { }

    call(loaderState: LoaderState): void {
        if (loaderState.background) {
            this.backgroundRequests = this.updateCounter(this.backgroundRequests, loaderState.show);
            this.emitIfChanged(this.backgroundLoadingSubject, this.backgroundRequests > 0);
            return;
        }

        this.foregroundRequests = this.updateCounter(this.foregroundRequests, loaderState.show);
        this.emitIfChanged(this.foregroundLoadingSubject, this.foregroundRequests > 0);
    }

    private updateCounter(current: number, show: boolean): number {
        return Math.max(0, current + (show ? 1 : -1));
    }

    private emitIfChanged(subject: BehaviorSubject<boolean>, loading: boolean): void {
        if (subject.value !== loading) {
            subject.next(loading);
        }
    }
}
